<div class="p-20-px">
  <div *ngIf="!noData" class="h-100">
    <app-topic-count [list]="topicCountList">
      <app-utilisation-status [utilisation]="overallUtilisation" [title]="MESSAGES?.OVERALL_STATUS" [type]="'block'"
        class="prefix">
      </app-utilisation-status>
    </app-topic-count>
    <app-hexagon-list [list]="moduleMetrics"></app-hexagon-list>
  </div>
  <div *ngIf="noData" class="text-center">
    <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="No Data">
  </div>
</div>